import * as React from 'react';

type PricingPageHeroProps = {
  title?: string;
  subtitle?: string;
};

/** Headline + subtitle shown above the pricing toggle. */
export function PricingPageHero({
  title = 'Turn your screen share into a finished video in minutes.',
  subtitle = 'Studio-quality AI voices and avatars, no editing skills. Pick the plan that matches how much you ship.'
}: PricingPageHeroProps): React.JSX.Element {
  return (
    // pb-0 neutralizes the marketing app's container vertical padding (60-96px
    // bottom); the dashboard container has no vertical padding, so it's a no-op there.
    <div className="container pb-0 pt-8 text-center">
      <h1 className="mx-auto max-w-3xl text-balance text-3xl font-bold tracking-tight sm:text-4xl">
        {title}
      </h1>
      <p className="mx-auto mt-4 max-w-xl text-balance text-base text-muted-foreground sm:text-lg">
        {subtitle}
      </p>
    </div>
  );
}
